// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__S25ug","colMin":"styles_colMin__3zmyM"};